<template>
<div class="chatPageContainer">
  <div v-if="marunage" class="chatPageContainer__side">
    <ul class="chatPageList">
      <li class="chatPageList__backLinkContainer">
        <a href="/chats/" class="ui button basic fluid compact"><i class="fas fa-chevron-left"></i> チャット一覧に戻る</a>
      </li>
      <li v-for="chat in marunage.chats" :key="chat.id" class="chatPageList__chatUserContainer">
        <a v-if="chat.chat_url" :href="chat.chat_url" class="chatPageList__chatUserLink" :class="{'chatPageList__chatUserLink--current': chat.id === currentChatId}">
          <span class="chatPageList__chatUserImage" :style="backgroundImage(imageUrl('/marunagekun.png'))"></span>
          {{ chat.label }}
        </a>
      </li>
    </ul>
    
    <div class="chatPageProposalList">
      <h3 class="chatPageProposalList__title">候補リスト ({{ marunage.marunage_shops.length }})</h3>
      <div class="chatPageProposalList__itemContainer">
        <div v-for="banquet in marunage.marunage_shops" :key="banquet.id" class="chatPageProposalList__item">
          <div class="chatPageProposalList__shopInfo">
            <div class="chatPageProposalList__shopImage" :style="backgroundImage(banquet.shop.main_image.urls.small_square)"></div>
            <span class="chatPageProposalList__shopTitle">{{ banquet.shop.name }}</span>
          </div>
          <div v-if="banquet.shop.is_public && banquet.shop.rank !== 'D'" class="chatPageProposalList__buttonContainer">
            <a :href="banquet.shop.detail_url" target="_blank" class="ui button mini compact">詳しく見る</a>
            <button v-if="banquet.status === 'none'" class="ui button mini compact"
                    :class="{'loading disabled': banquet.waiting, 'green': banquet.candidate, 'orange': !banquet.candidate}"
                    @click="banquet.candidate ? openShopChat(banquet) : like(banquet)">{{ banquet.candidate ? 'チャットする' : '空き確認' }}
            </button>
            <a v-else-if="banquet.chat_url" :href="banquet.chat_url">
              <button class="ui button mini compact"
                      :class="{'green': banquet.candidate || banquet.status === 'active',
                                'orange': !(banquet.candidate || banquet.status === 'active')}">{{ banquet.status_label }}
              </button>
            </a>
            <button v-else class="ui button mini disabled compact"
                    :class="{'green': banquet.candidate || banquet.status === 'active',
                              'orange': !(banquet.candidate || banquet.status === 'active')}">{{ banquet.status_label }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="marunage" class="chatPageContainer__topSelector">
    <div class="field">
      <dropdown v-model="selectedChatId" @change="changeChat()" class="fluid">
        <option v-if="chat.chat_url" v-for="chat in marunage.chats" :key="chat.id" :value="chat.id">{{ chat.label }}</option>
      </dropdown>
    </div>
  </div>

  <timeline :fetch-marunage="fetchMarunage"
            :like="like"
            :open-shop-chat="openShopChat"
            :open-marunage-edit-dialog="openMarunageEditDialog"
            :open-banquets-dialog="openBanquetsDialog"
            :open-candidate-dialog="openCandidateDialog"
            ref="timeline"></timeline>

  <div v-if="marunage" id="marunage-edit-dialog" class="ui small modal">
    <i v-if="holder.email" class="close icon"></i>
    <div class="header">
      <span v-if="holder.email">希望条件編集</span>
      <span v-else>通知先メールアドレス設定</span>
    </div>
    <div v-if="holder.email" class="scrolling content">
      <form @submit.prevent="saveMarunage" class="ui form" :class="{'warning': marunageEditForm.hasErrors()}">
        <div class="two column fields">
          <div class="required field">
            <label>人数</label>
            <dropdown v-model="marunageEditForm.model.people" :options="consts.MARUNAGE_PEOPLE" :placeholder="'人数'"></dropdown>
            <validation-message :form="marunageEditForm" :field="'people'"></validation-message>
          </div>
          <div class="required field">
            <label>一人あたりの予算</label>
            <dropdown v-model="marunageEditForm.model.price" :options="consts.MARUNAGE_PRICE" :placeholder="'一人あたりの予算'"></dropdown>
            <validation-message :form="marunageEditForm" :field="'price'"></validation-message>
          </div>
        </div>
        <div class="two column fields">
          <div class="required field">
            <label>利用日</label>
            <datepick v-model="marunageEditForm.model.event_date" :placeholder="'希望日'" :from="3"></datepick>
            <validation-message :form="marunageEditForm" :field="'event_date'"></validation-message>
          </div>
          <div class="required field" :class="{'error': marunageEditForm.hasError('event_time')}">
            <label>開始時間</label>
            <dropdown v-model="marunageEditForm.model.event_time" :options="consts.MARUNAGE_EVENT_TIME" :placeholder="'希望時間'"></dropdown>
            <validation-message :form="marunageEditForm" :field="'event_time'"></validation-message>
          </div>
        </div>
        <div class="two column fields">
          <div class="required field">
            <label>メールアドレス</label>
            <input type="text" v-model="marunageEditForm.model.email" :placeholder="'メールアドレス'">
            <validation-message :form="marunageEditForm" :field="'email'"></validation-message>
          </div>
          <div class="required field">
            <label>電話番号</label>
            <input type="text" v-model="marunageEditForm.model.tel" :placeholder="'電話番号'">
            <validation-message :form="marunageEditForm" :field="'tel'"></validation-message>
          </div>
        </div>
        <div class="field">
          <label>その他希望条件</label>
          <textarea rows="3" v-model="marunageEditForm.model.note" placeholder="会社の送別会の会場を探しています。
完全個室で落ち着いた場所を希望します。"></textarea>
        </div>
      </form>
    </div>
    <div v-else class="scrolling content">
      <div class="ui positive message">通知先メールアドレスを設定してください</div>
      <form @submit.prevent="saveMarunage" class="ui form" :class="{'warning': marunageEditForm.hasErrors()}">
        <div class="required field">
          <label>メールアドレス</label>
          <input type="text" v-model="marunageEditForm.model.email" :placeholder="'メールアドレス'">
          <validation-message :form="marunageEditForm" :field="'email'"></validation-message>
        </div>
      </form>
    </div>
    <div class="actions">
      <div class="ui green button" :class="{'loading disabled': marunageEditForm.waiting}" @click="saveMarunage()">保存する</div>
    </div>
  </div>

  <div id="marunage-guest-edit-dialog" class="ui small modal">
    <div class="scrolling content">
      <form class="ui form" @submit.prevent="saveMarunageForGuest()" :class="{'warning': marunageGuestEditForm.hasErrors()}">
        <div class="ui positive message">お店の予約間違いを防止するためにお客様のお名前の入力をお願いします</div>
          <div class="required field">
            <label>お名前(カナ)</label>
            <input v-model="marunageGuestEditForm.model.name_kana" type="text" :placeholder="'お名前(カナ)'">
            <validation-message :form="marunageGuestEditForm" :field="'name_kana'"></validation-message>
          </div>
      </form>
    </div>
    <div class="actions">
      <div class="ui green button" :class="{'loading disabled': marunageGuestEditForm.waiting}" @click="saveMarunageForGuest()">保存する</div>
    </div>
  </div>

  <div id="banquets-dialog" class="ui modal" v-if="marunage">
    <i class="close icon"></i>
    <div class="header">候補リスト</div>
    <div class="scrolling content">
      <div class="chatPageProposalDialog">
        <div class="chatPageProposalDialog__item" v-for="banquet in marunage.marunage_shops" :key="banquet.id">
          <div class="chatPageProposalDialog__shopImage" :style="backgroundImage(banquet.shop.main_image.urls.medium)">
          </div>
          <p class="chatPageProposalDialog__shopName">{{ banquet.shop.name }}</p>
          <div v-if="banquet.shop.is_public && banquet.shop.rank !== 'D'" class="chatPageProposalDialog__buttonContainer">
            <a :href="banquet.shop.detail_url" target="_blank" class="ui button compact">詳しく見る</a>
            <button v-if="banquet.status === 'none'" class="ui button compact"
                    :class="{'loading disabled': banquet.waiting, 'green': banquet.candidate, 'orange': !banquet.candidate}"
                    @click="banquet.candidate ? openShopChat(banquet) : like(banquet)">{{ banquet.candidate ? 'チャットする' : '空き確認' }}
            </button>
            <button v-else class="ui button disabled compact"
                    :class="{'green': banquet.candidate || banquet.status === 'active',
                              'orange': !(banquet.candidate || banquet.status === 'active')}">{{ banquet.status_label }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui cancel button">閉じる</div>
    </div>
  </div>

  <div id="candidate-dialog" class="ui modal" v-if="candidate">
    <i class="close icon"></i>
    <div class="header">立候補詳細</div>
    <div class="scrolling content">
      <candidate-detail :candidate="candidate"></candidate-detail>
    </div>
    <div class="actions">
      <div class="ui cancel button">閉じる</div>
    </div>
  </div>

</div>

</template>

<script>
import timeline from './_timeline.vue';
import candidateDetail from './../../components/candidateDetail.vue';

export default {
    components: {
        timeline: timeline,
        candidateDetail: candidateDetail
    },
    props: {
        chatDetailApiUrl: {
            required: true,
            type: String
        }
    },
    data: function() {
        return {
            getChatForm: this.createForm(),
            getMarunageForm: this.createForm(),
            marunageEditForm: this.createForm(),
            marunageGuestEditForm: this.createForm(),
            selectedChatId: this.pathParams().chat_id,
            chat: null,
            marunage: null,
            candidate: null,
        };
    },
    created: function() {
        this.getChatForm.get(this.chatDetailApiUrl, function(response) {
            this.chat = response.data;
            this.fetchMarunage().then(function() {
                this.$refs.timeline.render(this.chat);
                this.setInterval(this.fetchMarunage, 60 * 1000, false);
            }.bind(this));
        });
    },
    computed: {
        currentChatId: function() {
            return Number(this.pathParams().chat_id);
        },
        holder: function() {
            return this.marunage.member ? this.marunage.member : this.marunage;
        }
    },
    methods: {
        changeChat: function() {
            _.forEach(this.marunage.chats, function(chat) {
                if (chat.id === this.selectedChatId) {
                    window.location.href = chat.chat_url;
                }
            }.bind(this));
        },
        fetchMarunage: function() {
            return this.getMarunageForm.get(this.chat.marunage_detail_api_url, function(response) {
                this.marunage = response.data;
                this.$refs.timeline.updateMarunage(response.data);
            });
        },
        like: function(banquet) {
            banquet.waiting = true;
            this.createForm().put(banquet.like_api_url, function(response) {
                banquet.waiting = false;
                _.extend(banquet, response.data);
                this.$refs.timeline.fetchComments();
                this.pushDataLayer({
                    'category': '気になる',
                });
            });
        },
        openShopChat: function(banquet) {
            banquet.waiting = true;
            this.createForm().post(banquet.open_shop_chat_url, function() {
                banquet.waiting = false;
                this.$refs.timeline.fetchComments();
            });
        },

        openBanquetsDialog: function() {
            $('#banquets-dialog').modal('show');
        },
        openMarunageEditDialog: function() {
            var $dialog = $('#marunage-edit-dialog');
            if ($dialog.is('.visible')) {
                return;
            }
            this.marunageEditForm = this.createForm(_.pick(this.marunage, [
                'area', 'area_detail', 'people', 'price', 'event_date', 'event_time', 'email', 'tel', 'note'
            ]));
            $('#marunage-edit-dialog').modal({
                autofocus: false,
                closable: !!this.holder.email
            }).modal('show');
        },
        openMarunageGuestEditDialog: function() {
            var $dialog = $('#marunage-guest-edit-dialog');
            if ($dialog.is('.visible')) {
                return;
            }
            this.marunageGuestEditForm = this.createForm(_.pick(this.marunage, [
                'name', 'name_kana'
            ]));
            $dialog.modal({closable: false}).modal('show');
        },
        openCandidateDialog: function(candidate) {
            this.candidate = candidate;
            this.$nextTick(function() {
                $('#candidate-dialog').modal('show');
            });
        },
        saveMarunage: function() {
            this.marunageEditForm.put(this.chat.marunage_detail_api_url, function(response) {
                this.marunage = response.data;
                $('#marunage-edit-dialog').modal('hide');
            });
        },
        saveMarunageForGuest: function() {
            this.marunageGuestEditForm.put(this.chat.marunage_detail_guest_api_url, function(response) {
                window.location.reload();
            });
        },
    }
};
</script>
